import React from "react";
import "./index.scss";
import footerLogo from "../../assets/topbarLogo.png"
import qrCode from "../../assets/qrCode.png"
import jt2 from "../../assets/jt2.png"
import animateCss from "../../utils";
import $ from "jquery";
import { Link } from "react-router-dom";

class Footer extends React.Component  {

    mouseIn(i, e) {
        if (i <= 3) {
            animateCss("#normal"+i, "slideOutRight")
        }
        animateCss("#line" + i, "slideInLeft")
        .then(node => {
            node.style.visibility = "visible"
        })
    }

    mouseOut(i, e) {
        if (i <= 3) {
            document.getElementById("normal"+i).classList = ["normal"]
            animateCss("#normal"+i, "slideInLeft")
        }
        animateCss("#line" + i, "slideOutRight")
        .then(node => {
            node.classList = ["underline"]
            node.style.visibility = "hidden"
        })
    }

    backTop() {
        window.scrollTo(0, 0)
        this.setState({ isShow: true })
        $(".hb-top-bar")[0].classList = ["hb-top-bar"]
        animateCss($(".hb-top-bar")[0], "slideInDown")
        .then(()=>{
          $(".hb-top-bar")[0].style.visibility = "visible"
        })
    }

    scrollTo() {
        document.getElementsByClassName("project-part-2")[0].scrollIntoView()
    }

    scrollToTarget(target) {
        document.getElementsByClassName(target)[0].scrollIntoView()
    }

    render() {
        return <div className="footer">
            <div className="side-tool-footer">
                <div className="vertical-line"></div>
                <div onClick={() => this.backTop()} style={{height: "2.2rem"}}>
                    <span>回</span>
                    <span>顶</span>
                    <span>部</span>
                </div>
            </div>
        <div className="footer-left">
            <img src={footerLogo} className="footer-logo"/>
            <div className="company-info">
                <img src={qrCode} className="qr-code"/>
                <div className="contact">
                    <div>邮箱：support@humanbrain.cn</div>
                    <div className="address">地址 : 北京市海淀区颐和园路2号未来科技大厦4层412室</div>
                    {/* <img src={tel} className="tel"/> */}
                    {/* <div>电话：010-6275-5625</div> */}
                </div>
            </div>
            <div className="copyright">
                <p>Copyright © 北京慧脑云计算有限公司</p>
                <p>京ICP备17053269号-1  京公网安备 11010802025148号</p>
            </div>
        </div>
        <div className="footer-right">
            <div className="about footer-hidden">
                <div className="title" onMouseEnter={()=>this.mouseIn(4)} onMouseLeave={()=>this.mouseOut(4)}>
                    <span onClick={() => window.scrollTo(0,0)}><Link to="/about-us">关于我们</Link></span>
                    <div className="underline" id="line4"></div>
                </div>
                <ul>
                    <li 
                        onMouseEnter={()=>this.mouseIn(5)} 
                        onMouseLeave={()=>this.mouseOut(5)}
                        onClick={() => window.scrollTo(0,0)}
                    >
                        <Link to="/about-us">公司简介</Link>
                        <div className="underline" id="line5"></div>
                    </li>
                    <li 
                        onMouseEnter={()=>this.mouseIn(6)} 
                        onMouseLeave={()=>this.mouseOut(6)} 
                        onClick={()=>this.scrollToTarget("about-part-2")}
                    >
                        <Link to={{ pathname: "/about-us", state: { target: "about-part-2" } }}>发展历程</Link>
                        <div className="underline" id="line6">
                    </div></li>
                    <li 
                        onMouseEnter={()=>this.mouseIn(7)} 
                        onMouseLeave={()=>this.mouseOut(7)}
                        onClick={()=>this.scrollToTarget("about-part-3")}
                    >
                        <Link to={{ pathname: "/about-us", state: { target: "about-part-3" } }}>团队介绍</Link>
                        <div className="underline" id="line7"></div>
                    </li>
                    <li></li>
                </ul>
                <div 
                    className="latest-news"
                    onMouseEnter={()=>this.mouseIn(9)} 
                    onMouseLeave={()=>this.mouseOut(9)}
                    onClick={() => window.scrollTo(0,0)}
                >
                    <Link to="/latest-news">新闻动态</Link>
                    <div className="underline" id="line9"></div>
                </div>
            </div>
            <div className="project-line" >
                <div className="title footer-hidden" 
                    onMouseEnter={(e)=>this.mouseIn(10, e)} 
                    onMouseLeave={()=>this.mouseOut(10)}
                    onClick={() => window.scrollTo(0,0)}
                >
                    <Link to={{ pathname: "/project-pipe", state: { activeSlide: 1 } }}>系列产品</Link>
                    <div className="underline" id="line10"></div>
                </div>
                <ul>
                    <li onMouseEnter={()=>this.mouseIn(11)} onMouseLeave={()=>this.mouseOut(11)} onClick={() => this.scrollTo()}>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 1, goToBar: true } }}>多模态脑影像管理计算分析</Link>
                            <div className="underline" id="line11"></div>
                        </span>
                        
                    </li>
                    <li onMouseEnter={()=>this.mouseIn(12)} onMouseLeave={()=>this.mouseOut(12)} onClick={() => this.scrollTo()}>
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 1, goToBar: true } }}>
                                多模态脑影像数据管理计算分析平台    
                            </Link><div className="underline" id="line12"></div>
                        </span>
                    </li>
                    <li onMouseEnter={()=>this.mouseIn(13)} onMouseLeave={()=>this.mouseOut(13)} onClick={() => this.scrollTo()}>
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 2, goToBar: true } }}>
                                多模态脑影像数据质控与管理系统
                            </Link>
                            <div className="underline" id="line13"></div>
                        </span>
                        
                    </li>
                    <li onMouseEnter={()=>this.mouseIn(14)} onMouseLeave={()=>this.mouseOut(14)} onClick={() => this.scrollTo()}>
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 3, goToBar: true } }}>
                                数据管理计算分析平台
                            </Link>
                            <div className="underline" id="line14"></div>
                        </span>
                        
                    </li>
                    <li></li>
                    {/* <li onMouseEnter={()=>this.mouseIn(15)} onMouseLeave={()=>this.mouseOut(15)}>
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">数据处理分析服务<div className="underline" id="line15"></div></span>
                    </li> */}
                </ul>
                <div className="latest-news">
                    <span
                        onMouseEnter={()=>this.mouseIn(16)} 
                        onMouseLeave={()=>this.mouseOut(16)} 
                        className="inline-flex footer-hidden"
                        onClick={() => {
                            window.scrollTo(0,0)
                        }}
                    >
                        <Link to="/user-case">用户案例</Link>
                        <div className="underline" id="line16"></div>
                    </span>
                </div>
            </div>
            <div className="project-line-ext">
                <ul>
                    <li 
                        onMouseEnter={()=>this.mouseIn(17)} 
                        onMouseLeave={()=>this.mouseOut(17)}
                        onClick={() => this.scrollTo()}
                    >
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 4, goToBar: true } }}>癫痫致痫灶无创精准定位</Link>
                            <div className="underline" id="line17"></div>
                        </span>
                    </li>
                    <li
                        onMouseEnter={()=>this.mouseIn(18)} 
                        onMouseLeave={()=>this.mouseOut(18)}
                        onClick={() => this.scrollTo()}
                    >
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 4, goToBar: true } }}>癫痫致痫灶精准定位系统</Link>
                            <div className="underline" id="line18"></div>
                        </span>
                    </li>
                    <li
                        onMouseEnter={()=>this.mouseIn(19)} 
                        onMouseLeave={()=>this.mouseOut(19)}
                        onClick={() => this.scrollTo()}
                    >
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">
                            <Link to={{ pathname: "/project-pipe", state: { activeSlide: 5, goToBar: true } }}>临床癫痫多模态数据库平台</Link>
                            <div className="underline" id="line19"></div>
                        </span>
                    </li>
                    {/* <li
                        
                        onMouseEnter={()=>this.mouseIn(20)} 
                        onMouseLeave={()=>this.mouseOut(20)}
                    >
                        <img src={jt2} className="jt"/>
                        <span className="inline-flex footer-hidden">癫痫多模态数据专病数据库<div className="underline" id="line20"></div></span>
                    </li> */}
                    <li></li>
                </ul>
            </div>
        </div>
    </div>
    }
}

export default Footer;